import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const MobileStatLink = ({
  title,
  view,
  isSelectedView,
  Icon,
  handleToView,
}) => {
  return (
    <div className="level-item">
      <div
        className={`has-text-centered ${
          isSelectedView ? 'has-text-primary ' : 'has-text-link'
        }`}
      >
        <button
          className="button is-ghost"
          onClick={(e) => handleToView(view, e)}
        >
          <Icon
            className={`is-size-4 ${
              isSelectedView ? 'has-text-primary ' : 'has-text-link'
            }`}
          />
        </button>
        <p className="is-size-7">{title}</p>
      </div>
    </div>
  )
}

export default MobileStatLink
